/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/TranslationResource'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./TranslationResource'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.EntityChange = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.TranslationResource);
  }
}(this, function(ApiClient, TranslationResource) {
  'use strict';




  /**
   * The EntityChange model module.
   * @module model/EntityChange
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>EntityChange</code>.
   * @alias module:model/EntityChange
   * @class
   */
  var exports = function() {
    var _this = this;









  };

  /**
   * Constructs a <code>EntityChange</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EntityChange} obj Optional instance to populate.
   * @return {module:model/EntityChange} The populated <code>EntityChange</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('EntityType')) {
        obj['EntityType'] = ApiClient.convertToType(data['EntityType'], 'String');
      }
      if (data.hasOwnProperty('EntityID')) {
        obj['EntityID'] = ApiClient.convertToType(data['EntityID'], 'Integer');
      }
      if (data.hasOwnProperty('UserID')) {
        obj['UserID'] = ApiClient.convertToType(data['UserID'], 'Integer');
      }
      if (data.hasOwnProperty('ChangeType')) {
        obj['ChangeType'] = ApiClient.convertToType(data['ChangeType'], 'Integer');
      }
      if (data.hasOwnProperty('TimeStamp')) {
        obj['TimeStamp'] = ApiClient.convertToType(data['TimeStamp'], 'Date');
      }
      if (data.hasOwnProperty('FriendlyType')) {
        obj['FriendlyType'] = TranslationResource.constructFromObject(data['FriendlyType']);
      }
      if (data.hasOwnProperty('FriendlyName')) {
        obj['FriendlyName'] = ApiClient.convertToType(data['FriendlyName'], 'String');
      }
      if (data.hasOwnProperty('OptionalDetails')) {
        obj['OptionalDetails'] = ApiClient.convertToType(data['OptionalDetails'], Object);
      }
    }
    return obj;
  }

  /**
   * @member {String} EntityType
   * @default ''
   */
  exports.prototype['EntityType'] = '';
  /**
   * @member {Integer} EntityID
   * @default 0
   */
  exports.prototype['EntityID'] = 0;
  /**
   * @member {Integer} UserID
   * @default 0
   */
  exports.prototype['UserID'] = 0;
  /**
   * @member {Integer} ChangeType
   * @default 0
   */
  exports.prototype['ChangeType'] = 0;
  /**
   * @member {Date} TimeStamp
   */
  exports.prototype['TimeStamp'] = undefined;
  /**
   * @member {module:model/TranslationResource} FriendlyType
   */
  exports.prototype['FriendlyType'] = undefined;
  /**
   * @member {String} FriendlyName
   * @default ''
   */
  exports.prototype['FriendlyName'] = '';
  /**
   * @member {Object} OptionalDetails
   */
  exports.prototype['OptionalDetails'] = undefined;



  return exports;
}));


